import { createContext } from 'react';
import { WriterContextType } from '../types';

/**
 * Separado de WriterProvider.tsx para que Fast Refresh de Vite funcione correctamente.
 * Un archivo que exporta tanto un Context (no-componente) como un Provider (componente)
 * es incompatible con Fast Refresh y provoca full page reloads.
 */
export const WriterContext = createContext<WriterContextType | null>(null);
